import Vue from 'vue'
import Vuex from 'vuex'

import * as ServiceClient from '../shared/service-clients/service-clients'
import ServiceFactory from '../shared/service-clients/serviceClientFactory'
import {FileServiceClient, FileDto, BlobFileInfosDto, PersistFileDto} from '../shared/service-clients/service-clients'
import Enum from '../shared/enum'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    isLoggedIn: false,
    currentUser: null,
    files: [],
    deletedFiles: [],
    env: process.env.NODE_ENV,
  },
  mutations: {
    login(state, payload) {
      if (payload && payload.rememberClient) {
        let expirationInDays = payload.expireInSeconds / 60 / 60 / 24
        Vue.cookie.set('accessToken', payload.accessToken, expirationInDays)
        Vue.cookie.set('encryptedAccessToken', payload.encryptedAccessToken, expirationInDays)
        Vue.cookie.set('userId', payload.userId, expirationInDays)
        Vue.cookie.set('loginExpirationInSeconds', payload.expireInSeconds, expirationInDays)
      }
      state.isLoggedIn = true
      state.currentUser = payload.currentUser
    },
    logout(state) {
      Vue.cookie.delete('accessToken')
      Vue.cookie.delete('encryptedAccessToken')
      Vue.cookie.delete('userId')
      Vue.cookie.delete('loginExpirationInSeconds')
      state.isLoggedIn = false
      state.currentUser = null
    },
    addFiles(state, fs) {
      state.files = state.files.concat(fs)
    },
    addFile(state, file) {
      state.files.push(file)
    },
    removeFile(state, index) {
      var array = state.files.splice(index, 1)
      state.deletedFiles.push(array[0])
    },
    clearFiles(state) {
      state.files = []
    },
  },
  actions: {
    deleteFile({commit}, index) {
      commit('removeFile', index)
    },
    fetchFiles({commit}, param) {
      commit('clearFiles')

      let service = ServiceFactory.create(FileServiceClient)
      service
        .getAll(param.id, param.entite, '', param.fileType, '', 0, 10000)
        .then(res => {
          commit('addFiles', res.items)
        })
        .catch(err => {
          console.log(err)
        })
    },
    uploadFiles({commit}, param) {
      let baseUrl = process.env.API_URL
      let accessToken = Vue.cookie.get('accessToken')

      return new Promise(function(resolve, reject) {
        let xhr = new XMLHttpRequest()
        xhr.open('POST', baseUrl + '/temp-files')
        xhr.setRequestHeader('Authorization', 'Bearer ' + accessToken)
        xhr.onreadystatechange = e => {
          if (xhr.readyState === xhr.DONE) {
            if (xhr.status === 200) {
              let data = JSON.parse(xhr.responseText)

              let uploaded = _.map(data.result, map => {
                let dto = new BlobFileInfosDto()
                dto.init(map)
                dto.changed = true

                let fileDto = new FileDto()
                fileDto.init({
                  infos: dto,
                  name: dto.fileName,
                  entite: param.entite,
                  fileType: Enum.FileType.FILE,
                })

                return fileDto
              })

              commit('addFiles', uploaded)

              resolve({
                status: xhr.status,
              })
            } else {
              reject({
                status: xhr.status,
                statusText: xhr.statusText,
              })
            }
          }
        }
        xhr.send(param.formData)
      })
    },
    persistFiles({commit, state}, idEntite) {
      let service = ServiceFactory.create(FileServiceClient)

      let dto = new PersistFileDto()
      dto.init({
        idEntite: idEntite,
        persistedFiles: state.files,
        deletedFiles: state.deletedFiles,
      })

      return service.persistFiles(dto)
    },
    persistPhoto({}, fileWithMemberId) {
      let service = ServiceFactory.create(FileServiceClient)
      let files = []
      files.push(file)

      let dto = new PersistFileDto()
      dto.init({
        idEntite: idEntite,
        persistedFiles: files,
        deletedFiles: [],
      })

      return service.persistPhoto(dto)
    },
  },
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js